"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateVehicles = void 0;
const enums_1 = require("../../enums");
const validateVehicles = (vehicles) => {
    let missing = [];
    if (!vehicles)
        missing.push(enums_1.OrderValidation.MissingVehicle);
    if (!vehicles || (vehicles === null || vehicles === void 0 ? void 0 : vehicles.some((vehicle) => !(vehicle === null || vehicle === void 0 ? void 0 : vehicle.reference)))) {
        missing.push(enums_1.OrderValidation.MissingVehicleReference);
    }
    return Array.from(new Set(missing));
};
exports.validateVehicles = validateVehicles;
//# sourceMappingURL=vehicle.js.map